
    import Component from "vue-class-component";
    import Vue from "vue";
    import CardQuicklink from "@/features/dashboard/components/CardQuicklink.vue";
    import {Prop} from "vue-property-decorator";

    @Component({
        components: {
            CardQuicklink
        }
    })
    export default class NewDuplicateCard extends Vue {
        @Prop({ default: 'new-duplicate-application' })
        routeName!: string;

        @Prop({ required: true })
        seafarerId!: string;
    }
